import { render, staticRenderFns } from "./DUeditorEditor.vue?vue&type=template&id=16d93d0e&"
import script from "./DUeditorEditor.vue?vue&type=script&lang=js&"
export * from "./DUeditorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports